import { type FC, type ReactNode } from 'react';
import { Td, Th, Tr } from '@chakra-ui/react';
import { useToken } from '@chakra-ui/system';
import {
  Tag,
  Typography,
  XStack,
  YStack,
} from '@shinetools/sunshine-universal';

import SunshineIcon from 'components/_core/SunshineIcon';
import Tooltip from 'components/_core/Tooltip';

type RowData = {
  content: string | ReactNode;
};

type RowProps = {
  title: string;
  subtitle?: string;
  tooltip?: string;
  tag?: string;
  data: RowData[];
  withoutBorder?: boolean;
};

export const Row: FC<RowProps> = ({
  data,
  subtitle,
  tag,
  title,
  tooltip,
  withoutBorder,
}) => {
  const [grey300] = useToken('colors', ['grey.300']);

  return (
    <Tr
      borderY={`solid ${withoutBorder ? 0 : 1}px ${grey300}`}
      paddingY="space-32"
    >
      <Th paddingY="space-32" textAlign="left">
        <YStack gap="$space.8">
          <XStack
            alignItems="center"
            gap="$space.12"
            justifyContent="flex-start"
          >
            <Typography.Text variant="secondary">{title}</Typography.Text>
            {tooltip ? (
              <Tooltip description={tooltip} enableMobileFallback>
                <SunshineIcon
                  color="grey.700"
                  height="20px"
                  name="information"
                  width="20px"
                />
              </Tooltip>
            ) : null}
          </XStack>
          {subtitle ? (
            <Typography.Text variant="discreet">{subtitle}</Typography.Text>
          ) : null}

          {tag ? <Tag colorScheme="blue">{tag}</Tag> : null}
        </YStack>
      </Th>

      {data.map((item, index) => (
        <Td key={index} padding="space-32" textAlign="left">
          <Typography.Text>{item.content}</Typography.Text>
        </Td>
      ))}
    </Tr>
  );
};
